// Handle select dropdown caret rotation using event delegation
document.addEventListener('DOMContentLoaded', function() {
    // Track open state for each select
    const openStates = new WeakMap();
    
    // Handle mousedown events with delegation
    document.addEventListener('mousedown', function(e) {
        const select = e.target.closest('select[name="sort_by"]');
        if (!select) return;
        
        const selectWrapper = select.closest('.select');
        if (!selectWrapper) return;
        
        const isOpen = openStates.get(select) || false;
        
        if (!isOpen) {
            selectWrapper.classList.add('select--open');
            openStates.set(select, true);
        } else {
            selectWrapper.classList.remove('select--open');
            openStates.set(select, false);
        }
    });
    
    // Handle blur events with delegation
    document.addEventListener('blur', function(e) {
        const select = e.target.closest('select[name="sort_by"]');
        if (!select) return;
        
        const selectWrapper = select.closest('.select');
        if (!selectWrapper) return;
        
        setTimeout(function() {
            selectWrapper.classList.remove('select--open');
            openStates.set(select, false);
        }, 100);
    }, true); // Use capture phase for blur events
    
    // Handle change events with delegation
    document.addEventListener('change', function(e) {
        const select = e.target.closest('select[name="sort_by"]');
        if (!select) return;
        
        const selectWrapper = select.closest('.select');
        if (!selectWrapper) return;
        
        selectWrapper.classList.remove('select--open');
        openStates.set(select, false);
    });
    
    // Handle keyboard events with delegation
    document.addEventListener('keydown', function(e) {
        const select = e.target.closest('select[name="sort_by"]');
        if (!select) return;
        
        const selectWrapper = select.closest('.select');
        if (!selectWrapper) return;
        
        const isOpen = openStates.get(select) || false;
        
        if (e.key === 'Enter' || e.key === ' ') {
            if (!isOpen) {
                selectWrapper.classList.add('select--open');
                openStates.set(select, true);
            } else {
                selectWrapper.classList.remove('select--open');
                openStates.set(select, false);
            }
        } else if (e.key === 'Escape') {
            selectWrapper.classList.remove('select--open');
            openStates.set(select, false);
        }
    });
});